import ExcelGenerator from './excelGenerator';
import { downloadFile, generateFileName } from '../../utils/fileUtils';

class ExcelService {
  /**
   * Generates and downloads an Excel file from table data
   * @param {Array} data - Array of arrays (including headers)
   * @param {string} fileName - Base name for the file (without extension)
   * @param {string} sheetName - Name for the worksheet
   */
  static downloadTableAsExcel(data, fileName = 'export', sheetName = 'Sheet1') {
    try {
      const sheetsData = {
        [sheetName]: data
      };

      console.log(`fileName: ${fileName}`);
      console.log(`sheetName: ${sheetName}`);
      const excelBuffer = ExcelGenerator.generateExcelFile(sheetsData);
      
      // Convert buffer to blob for browser compatibility
      const excelBlob = new Blob([excelBuffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });
      
      const fullFileName = fileName;
      downloadFile(excelBlob, fullFileName);
    } catch (error) {
      console.error('Error generating Excel file:', error);
      throw new Error('Failed to generate Excel file');
    }
  }

  /**
   * Generates and downloads an Excel file from multiple tables
   * @param {Object} tablesData - Object with sheet names as keys and table data as values
   * @param {string} fileName - Base name for the file (without extension)
   */
  static downloadMultipleTablesAsExcel(tablesData, fileName = 'export') {
    try {
      const excelBuffer = ExcelGenerator.generateExcelFile(tablesData);
      
      // Convert buffer to blob for browser compatibility
      const excelBlob = new Blob([excelBuffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });
      
      const fullFileName = generateFileName(fileName, 'xlsx');
      downloadFile(excelBlob, fullFileName);
    } catch (error) {
      console.error('Error generating Excel file:', error);
      throw new Error('Failed to generate Excel file');
    }
  }
}

export default ExcelService; 